import { render } from "./CreateFormEmail.vue?vue&type=template&id=57901971&ts=true"
import script from "./CreateFormEmail.vue?vue&type=script&lang=ts"
export * from "./CreateFormEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__